import styled from '@emotion/styled';
import { SideBar } from '../common/SideBar/SideBar';
import { SideBarItem } from '../common/SideBarItem/SideBarItem';
import type { Category } from '../common/model/Category';

const StickyContainer = styled.div`
  max-height: calc(100vh - 110px);
  position: sticky;
  top: 70px;
`;

export interface CategoriesSideBarProps<T extends Category> {
  onCategorySelected: (category: T) => void;
  selectedCategory: T;
  categories: T[];
  suppressCategorySelection?: boolean;
}

export const CategoriesSideBar = <T extends Category>({
  onCategorySelected,
  selectedCategory,
  categories,
  suppressCategorySelection,
}: CategoriesSideBarProps<T>): JSX.Element | null => {
  return (
    <StickyContainer>
      <SideBar>
        {categories.map((category) => (
          <SideBarItem
            key={category.title}
            title={category.title}
            isSelected={
              suppressCategorySelection !== true && category.title === selectedCategory.title
            }
            onSelected={() => onCategorySelected(category)}
            count={category.count}
          />
        ))}
      </SideBar>
    </StickyContainer>
  );
};
